import { useComputed } from "@suse-o11y/signal";
import type React from "react";

import { useDelayed } from "~/tools/use-delayed";

import { useTimelineContext } from "../_context";

import type { TimelineHoveredEventBucket } from "./TimelineEventBucketsState";

const TIMELINE_BUCKET_POPOVER_HIDE_DELAY_MS = 500;

export const usePopoverBucket = (): [undefined | TimelineHoveredEventBucket, React.Dispatch<boolean>] => {
	const { eventBucketsState } = useTimelineContext();
	const hoveredBucket = useComputed(eventBucketsState.hoveredBucket);

	// it should delay the hovered bucket in a timeline to give a chance to hover the popover
	const delayedBucket = useDelayed(hoveredBucket, hoveredBucket == null ? TIMELINE_BUCKET_POPOVER_HIDE_DELAY_MS : 0);

	return [
		useComputed((monitor) => eventBucketsState.getBucketPopup(monitor), [eventBucketsState]) ?? delayedBucket,
		(isHovered: boolean) => eventBucketsState.setBucketPopup(isHovered ? delayedBucket : undefined),
	];
};
